import { Box, Stack, Typography } from '@mui/material';
import { Campaign } from 'domains/campaigns/types';
import { themeColors, brandColors } from 'colors';

type WinnerStoppedStatusProps = {
    campaign: Campaign;
};

const WinnerStoppedStatus = ({ campaign }: WinnerStoppedStatusProps) => {
    const winnerSend = campaign.sends?.find((send) => send.id === campaign.abTestConfig?.winnerSendId);
    const winnerName = winnerSend?.name || 'Winner';

    return (
        <Box
            sx={{
                backgroundColor: brandColors.stone,
                borderRadius: '8px',
                padding: '16px',
                paddingLeft: '24px',
            }}
        >
            <Stack spacing={0.5}>
                <Stack direction="row" alignItems="baseline" spacing={1.4}>
                    <Box
                        sx={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: themeColors.other.divider,
                        }}
                    />
                    <Typography>winner stopped</Typography>
                </Stack>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Sending of '{winnerName}' was stopped
                </Typography>
            </Stack>
        </Box>
    );
};

export default WinnerStoppedStatus;
